"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const resources_1 = require("../../../utils/resources");
const copy_move_resource_modal_1 = __importDefault(require("../../modal/copyMoveResourceModal/copy-move-resource-modal"));
const notify_1 = require("../../notify/notify");
const MoveEntityModal = ({ sbId, entity, type, onSubmit, isOpen, closeModal, extraPropsForModal }) => {
    const displayName = resources_1.ENTITY_DISPLAY_NAME[type];
    const validateModalForm = (0, react_1.useCallback)(({ location }) => {
        if (!location) {
            return { error: 'Location is required' };
        }
        if (location.sbId === sbId) {
            return { error: 'Selected location is equal to current location' };
        }
        return {};
    }, [sbId]);
    const handleMove = (0, react_1.useCallback)(async (data) => {
        closeModal();
        try {
            await onSubmit(data);
            (0, notify_1.renderNotify)({
                class_name: 'success',
                title: `${displayName} has been successfully moved`,
            });
        }
        catch (err) {
            console.error(`Error while moving ${displayName.toLowerCase()}`, err, data);
            (0, notify_1.renderNotify)({
                class_name: 'error',
                title: `${displayName} move failed`,
                text: `Failed to move the ${displayName.toLowerCase()}`,
            });
        }
    }, [closeModal, displayName, onSubmit]);
    return (react_1.default.createElement(copy_move_resource_modal_1.default, { isOpen: isOpen, currentSbLocationId: sbId, title: `Move ${displayName}`, action: "Move", validateModalForm: validateModalForm, closeModal: closeModal, item: entity, resourceType: type, onSubmitCallback: handleMove, showDescription: false, isEditable: false, isExpanded: true, shouldDisableFolderButtonForGlobal: true, hideGlobal: true, ...extraPropsForModal }));
};
MoveEntityModal.defaultProps = {
    isOpen: false,
    extraPropsForModal: {},
};
MoveEntityModal.propTypes = {
    isOpen: prop_types_1.default.bool,
    entity: prop_types_1.default.object.isRequired,
    type: prop_types_1.default.oneOf(resources_1.ENTITY_TYPE).isRequired,
    sbId: prop_types_1.default.number.isRequired,
    onSubmit: prop_types_1.default.func.isRequired,
    closeModal: prop_types_1.default.func.isRequired,
    extraPropsForModal: prop_types_1.default.object,
};
exports.default = MoveEntityModal;
//# sourceMappingURL=move-entity-modal.js.map